import { init } from "./init";
import { sanitizeData, sanitizeExpire } from "./Sanitize";

const actionTypes = {
  TERMINATE_CHILD: "TERMINATE_CHILD",
  RESET: "RESET",
};

const fetchReset = async (state) => {
  state = {
    ...state,
    isLoading: false,
    isStatus: true,
    expireToken: false,
    data: false,
  };
  return state;
};
const addPR = async (state, terminatechild) => {
  state = {
    ...state,
    isStatus: true,
    expireToken: false,
    data: terminatechild,
  };
  return state;
};

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.TERMINATE_CHILD:
      return addPR(state, action.terminatechild);
    case actionTypes.RESET:
      return fetchReset(state);
    default:
      return state;
  }
};

const index = {
  init,
  actionTypes,
  reducer,
};

export default index;
